module.exports = __webpack_public_path__ + "media/images/new_landing/favicon/favicon-e106909e9c0231334036330d460e142e.ico";